<ng-container *ngIf="type == 'amount'">
   <!-- Case: null → show hyphen -->
   <span *ngIf="amount == null">-</span>

   <!-- Case: exactly 0 → show 0 -->
   <span *ngIf="amount === 0" [ngStyle]="amountStyle">
      {{ 0 | sumPipe : currency || "" }}
   </span>

   <!-- Case: valid values >= 0.01 or <= -0.01 -->
   <span
      *ngIf="amount != null && amount !== 0 && absAmount >= 0.01"
      [ngStyle]="amountStyle"
   >
      {{ amount | sumPipe : currency || "" }}
   </span>

   <!-- Case: values between -0.01 and 0.01 (but not 0 or -1) -->
   <span
      class=""
      container="body"
      *ngIf="amount != null && amount !== 0 && absAmount < 0.01"
      ngbTooltip="{{ tooltipContent }}"
      [placement]="'auto'"
      [ngStyle]="amountStyle"
   >
      {{ isNegative ? ">-" : "<" }}{{ 0.01 | sumPipe : currency || "" }}
   </span>
</ng-container>

<ng-container *ngIf="type == 'percentage'">
   <span *ngIf="amount == null" [ngStyle]="amountStyle">-</span>
   <span
      class=""
      *ngIf="amount != null && (absAmount >= 0.01 || amount === 0)"
      [ngStyle]="amountStyle"
   >
      {{ amount | number : "1.2-2" }}%
   </span>
   <span
      class=""
      container="body"
      *ngIf="amount != null && absAmount < 0.01 && amount !== 0"
      ngbTooltip="{{ tooltipContent }}"
      [placement]="'auto'"
      [ngStyle]="amountStyle"
   >
      {{ isNegative ? ">-" : "<" }}0.01%
   </span>
</ng-container>

<ng-container *ngIf="type == 'number'">
   <span *ngIf="amount == null" [ngStyle]="amountStyle">-</span>
   <span
      class=""
      *ngIf="amount != null && (absAmount >= 0.01 || amount === 0)"
      [ngStyle]="amountStyle"
   >
      {{ amount | number : "1.0-2" }}
   </span>

   <span
      class=""
      container="body"
      *ngIf="amount != null && absAmount < 0.01 && amount !== 0"
      ngbTooltip="{{ tooltipContent }}"
      [placement]="'auto'"
      [ngStyle]="amountStyle"
   >
      {{ isNegative ? ">-" : "<" }} 0.01
   </span>
</ng-container>
